import { __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { ConfigContext } from '../config-provider';
import Column from './Column';
import useBuriedPoint from '../_util/hooks/useBuriedPoint';
export { ColumnProps, ColumnItemProps } from './Column';
const Footer = (props) => {
    useBuriedPoint('Footer');
    const { className, prefixCls: customizePrefixCls, children, style, bottom, maxColumnsPerRow, backgroundColor, columnLayout, theme = 'light' } = props, restProps = __rest(props, ["className", "prefixCls", "children", "style", "bottom", "maxColumnsPerRow", "backgroundColor", "columnLayout", "theme"]);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('footer', customizePrefixCls);
    const footerClassName = classnames(`${prefixCls}`, className, {
        [`${prefixCls}-${theme}`]: !!theme,
    });
    const shouldWrap = typeof maxColumnsPerRow === 'number' && maxColumnsPerRow > 0;
    return (React.createElement("footer", Object.assign({}, restProps, { className: footerClassName, style: Object.assign(Object.assign({}, style), { backgroundColor }) }),
        React.createElement("section", { className: classnames(`${prefixCls}-container`) }, React.createElement("section", { className: `${prefixCls}-columns`, style: {
                justifyContent: columnLayout,
                flexWrap: shouldWrap ? 'wrap' : undefined,
            } }, children)),
        bottom && (React.createElement("section", { className: classnames(`${prefixCls}-bottom`, {
                [`${prefixCls}-bottom-has-children`]: !!children,
            }) },
            React.createElement("div", { className: `${prefixCls}-bottom-container` }, bottom)))));
};
Footer.Column = Column;
export default Footer;
